import { Component } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';

import { L2 } from 'l2-lib/L2';
import { ProfileService } from '~/profile/profile.service';
import { RegisterService } from './register.service';
import { PwaAppService } from '~/shared/app.service';

@Component({
  templateUrl: './select-member.component.html',
  styleUrls: ['./select-member.component.css']
})
export class SelectMemberComponent {

  public _isLoading: boolean = true;
  public _memberData: any;

  public _selectedMem: any;

  public _product: any;

  constructor(public regService: RegisterService, public pwa: PwaAppService, public location: Location, public profileService: ProfileService, public router: Router) {

  }

  ngOnInit() {
    // console.log('Starting member select')

    
    try {

      let type = window.history.state;
      if(this.pwa?.appId?.toUpperCase() == 'C41A1369-B50A-413B-9D3C-A5398D53D329'/*BONITAS*/ 
          && type["memberSelect"]){
        
        DAL.Icev0.pwa.PolicyMemberGetMemberList({ pwaAppId: this.pwa.appId, policyMemberGuid: this.profileService.policyMemberGuid })
          .always(() => this._isLoading = false)
          .configure({ AutoProcessApiResponse: false, HttpMethod: "POST" })
          .ExecQuery()
          .then(r => {
            if (r.Message) {

              //1this.analytics.event("Registration", "Reg.Failed");
              //this._needsCaptchaRetry = true;
              L2.exclamation(r.Message);
              //if (r && r.Data && r.Data.OutputParms) this._regFailedMsg = r.Data.OutputParms.regFailedMsg;

            }
            else {
              this._memberData = r.Data.Table0;
            }

          });
      }

      
      if (this.regService && this.regService.registrationDetail) {

        let regData = this.regService?.registrationDetail?.regData;
       
        DAL.Icev0.pwa.PolicyMemberGetMemberList({ pwaAppId: this.pwa.appId, policyMemberGuid: regData.PolicyMemberGuid })
          .always(() => this._isLoading = false)
          .configure({ AutoProcessApiResponse: false, HttpMethod: "POST" })
          .ExecQuery()
          .then(r => {
            if (r.Message) {

              //1this.analytics.event("Registration", "Reg.Failed");
              //this._needsCaptchaRetry = true;
              L2.exclamation(r.Message);
              //if (r && r.Data && r.Data.OutputParms) this._regFailedMsg = r.Data.OutputParms.regFailedMsg;

            }
            else {
              this._memberData = r.Data.Table0;
            }
          });
      }
    }
    catch (e) {
      L2.handleException(e);
    }
  }

  confirm(memRow: any) {
    try {
      let type = window.history.state;

      if(type["memberSelect"]){
        let policyMemberDetail = this.profileService.primaryRegistration;
        this.profileService.register(memRow, memRow.ContactNumber, memRow.Member, memRow.ContactNumber);
        this.router.navigate(['/basic-ioa']);
      } else {
        this.profileService.register(memRow, this.regService?.registrationDetail?.contactNo, this.regService.registrationDetail.altContactName, this.regService.registrationDetail.altContactNo);
        this.router.navigate(['/']);
      }   
    }
    catch (e) {
      L2.handleException(e)
    }
  }
  
}
